(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name cycle.controller:CycleCtrl
	 *
	 * @description
	 *
	 */
	angular.module('snap').controller('SnapCtrl', SnapCtrl);

	function SnapCtrl(applicationConstants, CommonMasterData, MessageService,AdminSnapService, PopupManager) {
		var vm = this;
		vm.ctrlName = 'SnapCtrl';

		vm.model = {
			searchCriteria : {
				showAll : false
			},
			newPopover : {
				popOverFlag : false
			},
			masterList : {
				showNewSnapAddRow : false,
				newSnapToAdd : AdminSnapService.getSnapDTO(),
				populateScore : AdminSnapService.getSnapDTO(),
				cycleList : null
			},
			adminSnaps : [],// grid data
			cycleSearchAdaptedDTO : null
		};



		// load Cycles
		function loadCycles() {
			vm.model.masterList.showNewSnapAddRow = false;
			AdminSnapService.loadRosterSnaps(
							vm.model.searchCriteria.showAll,
							function(response) {
								vm.model.adminSnaps = response.snapList;

								angular.forEach(vm.model.adminSnaps, function (value, key) {
									value["showSubmit"] = true;
									value["scoreName"] = '';
									value["crewType"] = '';
					            });

								if(vm.model.masterList.cycleList == null){
									vm.model.masterList.cycleList = response.cycleList;
								}

							}, function() {
								console.log('Admin Cycles retrieval error');
							});
		}

		// set initial values for newly adding cycle
		vm.clickOnNewSnap = function() {
			vm.model.masterList.showNewSnapAddRow = !vm.model.masterList.showNewSnapAddRow;
		};

    vm.onRefresh = function() {
      loadCycles();
    };


    // when row is selected
		vm.selectAAdminCycelRow = function(selectedRowData, flag) {
			if (flag == 'add') {
				if (!!!vm.model.masterList.newSnapToAdd.snapName
						|| vm.model.masterList.newSnapToAdd.snapName != null
						|| vm.model.masterList.newSnapToAdd.cycle != null) {
					saveNewlyAddedCycle();
				}
			} else if (flag == 'clear') {
				loadCycles();
			} else if (flag == 'score') {
				scoreSnapShot(selectedRowData);
			}
		};

		//score snap shot
		function scoreSnapShot(selectedRowData) {

      var param = {};
      param.selectedRow = selectedRowData;

      PopupManager.openModal('ADD_ROSTER_SCORE_VERSION', param, onAddMemoClose);




			/*var populateScore = AdminSnapService.setSnapeScoreRequest(selectedRowData);*/

			/*AdminSnapService.scoreRosterSnap(
					populateScore,
							function(response) {
								if (response.success) {
									MessageService.success('Score Snap is Successfully saved!');
									vm.model.masterList.showNewSnapAddRow = !vm.model.masterList.showNewSnapAddRow;
								} else if (!response.success) {
									MessageService.error(response.error);
								}
								loadCycles();
							}, function(error) {
								MessageService.error(error[0]);
								loadCycles();
							});*/
		}

    function onAddMemoClose(param) {
    }

		//add new cycle
		function saveNewlyAddedCycle() {
			var saveSnapReq = AdminSnapService.setSaveSnapeRequest(vm.model.masterList.newSnapToAdd);
			AdminSnapService.saveRosterSnap(
							saveSnapReq,
							function(response) {
								if (response.success) {
									MessageService.success('Roster Snap score process started.');
									vm.model.masterList.showNewSnapAddRow = !vm.model.masterList.showNewSnapAddRow;
								} else {
									MessageService.error(response.errors[0]);
								}
								loadCycles();
							}, function(error) {
								MessageService.error(error[0]);
//								loadCycles();
							});
		}

		loadCycles();
	}
}());
